import { T } from '@/ui/tokens';

export function Spinner({ size = 22 }: { size?: number }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      border: `2px solid ${T.line2}`, borderTopColor: T.accent,
      animation: 'spin 0.8s linear infinite',
    }}/>
  );
}

export function FullPageLoader({ label }: { label?: string }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 14, background: T.bg,
    }}>
      <Spinner size={28}/>
      {label && <div style={{ fontSize: 12, color: T.textDim }}>{label}</div>}
    </div>
  );
}
